import { Injectable } from "@angular/core";
import { BehaviorSubject, distinctUntilChanged } from "rxjs";

// loading-spinner.service.ts
@Injectable({ providedIn: 'root' })
export class LoadingSpinnerService {
  private activeRequests = 0;
  private isLoading = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoading.asObservable().pipe(distinctUntilChanged());

  show() {
    this.activeRequests++;
    this.isLoading.next(true);
  }

  hide() {
    this.activeRequests = Math.max(0, this.activeRequests - 1);
    if (this.activeRequests === 0) this.isLoading.next(false);
  }

  forceHide() {
    this.activeRequests = 0;
    this.isLoading.next(false);
  }
}